import FragranceSection from './FragranceSection';

export default FragranceSection;
